<div class="container bgprodlist pt-3">
    
  <div class="mb-3">
      <div class="div-breadcrumb">
          <table>
              <tr>
                  <td>
                    <a href="">
                        <div class="d-flex flex-row div-icon">
                            <div class="back-icon">
                                <a href="/dashboard">
                                    <i class="bi bi-arrow-left pointer"></i>
                                </a>
                            </div>
                            <div class="back-text d-none d-sm-block">{{'back'|translate}}</div>
                        </div>
                    </a>
                  </td>
                  <td>
                    <nav class="cd-breadcrumb" aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/dashboard">{{'menu.product'|translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{{'menu.product_catalogue'|translate}}</li>
                      </ol>
                    </nav>                
                  </td>
              </tr>
          </table>
      </div>
  </div>
  
  <div class="row">
    <div class="col-12 mb-3">
      <div class="cd-title">{{'menu.product_catalogue'|translate}}</div>
    </div>

    <div class="col-12 mb-3">
      <div class="cd-quotes text-center py-3">
        <div class="my-1">
          <h3 class="pb-1">{{'product.product_catalogue_title'|translate}}</h3>
          <h5>{{'product.product_catalogue_desc'|translate}}</h5>
        </div>
      </div>
    </div>
  </div>


  <div class="">
    
    <div class="item-list">

        <div class="mb-4" *ngIf="AlldataProducts?.length > 0">


          <div class="row row-cols-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-5">
            <div class="col mb-4" *ngFor="let product of AlldataProducts; let i = index">
              <app-product-card 
                [images]="product?.imagesUrl"
                [title]="product?.productName"
                [company]="product?.vendorName"
                [currency]="product.currency?product.currency:'IDR'"
                [price]="product?.productPrice"
                [isNewCedaUi]="'newCedaUi'"
                location="{{ product.vendorCity? product.vendorCity+', ':''}}{{ product.vendorCountry}}"
                [isConfidential]="product.vendorName?'Y':'N'"
                url="/product/{{(product.companyDomain)?product.companyDomain:'view/'+product.vendorId}}/{{product.productSlugUrl}}"
              >
              </app-product-card>
            </div>
          </div>


        </div>       

    </div>
    <div *ngIf="PageLoading" class="loading pb-5">
      <div class="pb-5">
        <div class="text-center pt-5 pb-5">
          <div class="loader loader--style8" title="7">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
              </rect>
            </svg>
          </div>
        </div>  
      </div>  
    </div>
    <div *ngIf="!hasMore" class="end"></div>

  </div>



</div>
  
